import { getModuleEntryByErpModule } from '@/config/moduleEntries';

/**
 * Launcher module lists come from GET /v1/session/init (Redux auth slice).
 * No per-layout API sync — avoids duplicate calls to /v1/platform/modules.
 */
export function useLauncherModuleSync(): void {
  /* intentionally empty — session bootstrap is the single source of truth */
}

/** Whether the org has subscribed to this head-module app. */
export function isHeadModuleSubscribed(
  module: string,
  enabledModules: string[],
  accessibleModules?: string[],
): boolean {
  const upper = module.toUpperCase();
  if (!getModuleEntryByErpModule(upper)) return false;
  if (accessibleModules?.includes(upper)) return true;
  return enabledModules.includes(upper);
}
